import { BASE_PAGINATION_MODEL } from '~constants/paginationModels';
import { getDefaultPaginationModelByType } from '~utils/paginationModels';
import { createNamespacer, createReducer } from '~utils/reducers';

import actionTypes from '../actionTypes';

const nameSpace = 'LIST_FILTERS_BAR';

export const lfNS = createNamespacer(nameSpace);
export const lfAT = actionTypes.listFiltersBar;

const initialState = {
	filters: {
		activeTab: '',
		searchString: null,
	},
	shouldUpdateWarning: false,
	paginationModel: BASE_PAGINATION_MODEL,
	sortModel: [],
	screenType: '',
};

const handlers = {
	[lfNS(lfAT.CHANGE_FILTERS)]: (state, { payload }) => ({
		...state,
		filters: {
			...state.filters,
			activeTab: payload.activeTab,
			searchString: payload.searchString,
		},
		paginationModel: getDefaultPaginationModelByType(state.screenType),
		sortModel: [],
	}),
	[lfNS(lfAT.SET_ACTIVE_TAB)]: (state, { payload }) => ({
		...state,
		filters: {
			...state.filters,
			activeTab: payload,
			searchString: null,
		},
		paginationModel: getDefaultPaginationModelByType(state.screenType),
		sortModel: [],
	}),
	[lfNS(lfAT.SET_ACTIVE_TAB_SEARCH_PERSIST)]: (state, { payload }) => ({
		...state,
		filters: {
			...state.filters,
			activeTab: payload,
		},
		paginationModel: getDefaultPaginationModelByType(state.screenType),
		sortModel: [],
	}),
	[lfNS(lfAT.SET_SEARCH_STRING)]: (state, { payload }) => ({
		...state,
		filters: {
			...state.filters,
			searchString: payload,
		},
		paginationModel: getDefaultPaginationModelByType(state.screenType),
		sortModel: [],
	}),
	[lfNS(lfAT.SET_UPDATE_WARNING)]: (state, { payload }) => ({
		...state,
		shouldUpdateWarning: payload,
	}),
	[lfNS(lfAT.SET_SCREEN_TYPE)]: (state, { payload }) => ({
		...state,
		screenType: payload,
		paginationModel: getDefaultPaginationModelByType(payload),
	}),
	[lfNS(lfAT.SET_PAGINATION_MODEL)]: (state, { payload }) => ({
		...state,
		paginationModel: payload,
	}),
	[lfNS(lfAT.SET_SORT_MODEL)]: (state, { payload }) => ({
		...state,
		sortModel: payload,
	}),
};

export default createReducer(initialState, handlers, [nameSpace]);
